module.exports = __webpack_public_path__ + "static/img/xx_pic6.ac10410.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rizhi/xx_pic6.jpg
// module id = lsyA
// module chunks = 5